/** @param {import('immutable').Map} state */
export const selectIsDemo = (state) => Boolean(state.getIn(['ui', 'demo']));
